/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import LanguageSelect from '@/components/header/languageSelect';
import PowerBy from './powerBy';
import TermLink from './termLink';

export const Index: React.FC = () => {
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 80px;
      `}
    >
      <LanguageSelect />
      <div
        css={css`
          display: flex;
          align-items: center;
          flex-direction: row;
          margin-top: 40px;
          margin-bottom: 40px;
        `}
      >
        <PowerBy haveRightBorder={true} />
        <TermLink />
      </div>
    </div>
  );
};

export default Index;
